import * as type from '../../types/trans';
import {
    FOLIO_LIST_KARVY_RESPONSE, FOLIO_LIST_KARVY_FAILED, GET_REGISTERED_BANKS_RESPONSE, GET_REGISTERED_BANKS_FAILED,
    ORDER_GENERATION_RESPONSE, ORDER_GENERATION_FAILED, PAYMENT_REQUEST_RESPONSE, PAYMENT_REQUEST_FAILED,
    GET_PG_RESPONSE_RESPONSE, GET_PG_RESPONSE_FAILED, VALIDATE_BROKER_CODE_RESPONSE, VALIDATE_BROKER_CODE_FAILED, RESET_SELECTED_FUND,
    UPDATE_CART_ITEM_BY_SCHEME_CODE, PAYMENT_CHECK_MODE, PAYMENT_CHECK_NAME, UPDATE_CART_ORDER_REVIEW_ITEM_BY_SCHEME_CODE
} from "../../types/quickbuy";

let init = {
    schemeCode: null,
    cartBoxData: [],
    cartOrderReviewData: [],
    activeInvestor: "",
    investorDrop: [],
    panFolio: [],
    folioSelection: "",
    obFolio: null,
    obHolding: null,
    getfolioList: {},
    registerBankList: {},
    orderGenerationList: {},
    paymentRequest: {},
    pgResponse: {},
    validateBroker: {},
    PaymentCheckMode: '',
    PAYMENT_CHECK_NAME: ''
}

export default function quickcategoryReducer(state = init, action) {
    switch (action.type) {

        case type.CAT_SAVE_SCHEMECODE:
            return {
                ...state,
                schemeCode: action.payload,
            }

        case type.SAVE_CART_BOX:
            let aaa = [...state.cartBoxData];
            aaa.push(action.payload)
            return {
                ...state,
                cartBoxData: aaa,
            }

        case type.REPLACE_CART_BOX:
            let newCartBoxData = [];
            newCartBoxData.push(action.payload)
            return {
                ...state,
                cartBoxData: newCartBoxData,
            }

        case type.DEL_CART_BOX:
            /* let bbb = [];
            state.cartBoxData.map((curr, ind)=> {
                if(curr.OrderId !== action.payload){
                    bbb.push(curr);
                }
            }) */
            let bbb = state.cartBoxData;
            bbb = bbb.filter(function (obj) {
                return Object.keys(obj)[0] !== action.payload;
            })
            return {
                ...state,
                cartBoxData: bbb,
            }

        case type.RESET_CART_BOX:
            return {
                ...state,
                cartBoxData: [],
            }

        //start cart order review 
        case type.SAVE_CART_ORDER_REVIEW_DATA: {
            let aaa = [...state.cartBoxData];
            aaa.push(action.payload)
            return {
                ...state,
                cartOrderReviewData: aaa,
            }
        }

        case type.REPLACE_CART_ORDER_REVIEW_DATA: {
            let newCartBoxData = [];
            newCartBoxData.push(action.payload)
            return {
                ...state,
                cartOrderReviewData: newCartBoxData,
            }
        }

        case type.DEL_CART_ORDER_REVIEW_DATA: {
            let { schCode } = action.payload;
            let bbb = state.cartOrderReviewData;
            bbb = bbb.filter((obj) => obj.Scheme !== schCode);
            return {
                ...state,
                cartOrderReviewData: bbb,
            }
        }

        case type.RESET_CART_ORDER_REVIEW_DATA: {
            return {
                ...state,
                cartOrderReviewData: [],
            }
        }

        case UPDATE_CART_ORDER_REVIEW_ITEM_BY_SCHEME_CODE: {
            let aaa = [...state.cartOrderReviewData];
            let payload = action.payload;

            let Scheme = payload.Scheme;
            // Scheme,Amount
            let schemeIndex = aaa.findIndex(sch => {
                return sch.Scheme === Scheme
            });
            if (schemeIndex > -1) {
                aaa[schemeIndex] = { ...aaa[schemeIndex], ...payload };
                return { ...state, cartOrderReviewData: aaa }
            }
            return state;
        }
        //end cart order review   

        case RESET_SELECTED_FUND:
            return {
                ...state,
                cartBoxData: [],
            }

        case type.ACTIVE_INVESTOR:
            return {
                ...state,
                activeInvestor: action.payload,
            }

        case type.ACTIVE_PANDROPDOWN:
            return {
                ...state,
                investorDrop: action.payload,
            }

        case type.PAN_AGAIN_FOLIO:
            return {
                ...state,
                panFolio: action.payload,
            }

        case type.FOLIO_SELECTION_CART:
            return {
                ...state,
                folioSelection: action.payload,
            }

        case type.OB_FOLIOHOLDING_DATA:
            return {
                ...state,
                obFolio: action.payload.folioNumber,
                obHolding: action.payload.holdingMode
            }
        case FOLIO_LIST_KARVY_RESPONSE:
            return { ...state, getfolioList: action.payload }
        case FOLIO_LIST_KARVY_FAILED:
            return { ...state, getfolioList: action.payload }
        case GET_REGISTERED_BANKS_RESPONSE:
            return { ...state, registerBankList: action.payload }
        case GET_REGISTERED_BANKS_FAILED:
            return { ...state, registerBankList: action.payload }
        case ORDER_GENERATION_RESPONSE:
            return { ...state, orderGenerationList: action.payload }
        case ORDER_GENERATION_FAILED:
            return { ...state, orderGenerationList: action.payload }
        case PAYMENT_REQUEST_RESPONSE:
            return { ...state, paymentRequest: action.payload }
        case PAYMENT_REQUEST_FAILED:
            return { ...state, paymentRequest: action.payload }
        case GET_PG_RESPONSE_RESPONSE:
            return { ...state, pgResponse: action.payload }
        case GET_PG_RESPONSE_FAILED:
            return { ...state, pgResponse: action.payload }
        case VALIDATE_BROKER_CODE_RESPONSE:
            return { ...state, validateBroker: action.payload }
        case VALIDATE_BROKER_CODE_FAILED:
            return { ...state, validateBroker: action.payload }

        case PAYMENT_CHECK_MODE:
            return { ...state, PaymentCheckMode: action.payload }
        case PAYMENT_CHECK_NAME:
            return { ...state, paymentCheckName: action.payload }

        case UPDATE_CART_ITEM_BY_SCHEME_CODE: {
            let aaa = [...state.cartBoxData];
            let payload = action.payload;

            let Scheme = payload.Scheme;
            // Scheme,Amount
            let schemeIndex = aaa.findIndex(sch => {
                let code = Object.keys(sch)[0];
                return code === Scheme
            });
            if (schemeIndex > -1) {
                aaa[schemeIndex] = {
                    [Scheme]: { ...aaa[schemeIndex][Scheme], ...payload }
                };
                return { ...state, cartBoxData: aaa }
            }
            return state;
        }
        default:
            return state
    }
}